import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiLayers } from 'react-icons/fi';

function roleLabel(role) {
  switch (role) {
    case 'admin':
      return 'Administrador';
    case 'manager':
      return 'Gestor';
    case 'viewer':
      return 'Visualizador';
    default:
      return role || '—';
  }
}

function AdminNavbar({ toggleSidebar }) {
  const location = useLocation();
  const { user } = useAuth();

  const getSectionTitle = () => {
    const path = location.pathname;
    if (path === '/admin' || path === '/admin/') return 'Dashboard';
    if (path.includes('/relatorios')) return 'Relatórios de vendas';
    if (path.includes('/vendedores')) return 'Vendedores';
    if (path.includes('/funcionarios')) return 'Funcionários Winthor';
    if (path.includes('/grupos-metas')) return 'Grupos de Metas';
    if (path.includes('/metas')) return 'Metas';
    if (path.includes('/filtros')) return 'Filtros';
    if (path.includes('/variaveis')) return 'Variáveis';
    if (path.includes('/usuarios')) return 'Usuários';
    if (path.includes('/minha-conta')) return 'Minha Conta';
    return 'Dashboard';
  };

  return (
    <header className="header-modern">
      <div className="d-flex align-items-center gap-3">
        <button
          className="mobile-menu-btn"
          onClick={toggleSidebar}
          aria-label="Toggle Menu"
          type="button"
        >
          <span />
          <span />
          <span />
        </button>
        <h1 className="h5 mb-0 fw-bold text-dark">{getSectionTitle()}</h1>
      </div>

      <div className="user-info d-flex align-items-center gap-3">
        <div className="text-end d-none d-sm-block">
          <div className="fw-bold text-dark small">{user?.name || 'Usuário'}</div>
          <div className="text-muted extra-small" style={{ fontSize: '0.7rem' }}>
            {roleLabel(user?.role)}
          </div>
        </div>
        <div
          className="avatar-sm-modern bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold shadow-sm"
          style={{ width: '38px', height: '38px' }}
        >
          {(user?.name || 'U').substring(0, 1).toUpperCase()}
        </div>
      </div>
    </header>
  );
}

export default AdminNavbar;
